export default __webpack_public_path__ + "static/media/diploma-fengshui-2024.ba1efffa.jpeg";